import { render } from "./QuestionnaireList.vue?vue&type=template&id=3caeaafd&scoped=true"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js"

import "./QuestionnaireList.vue?vue&type=style&index=0&id=3caeaafd&lang=scss&scoped=true"
import "./QuestionnaireList.vue?vue&type=style&index=1&id=3caeaafd&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caeaafd"]])

export default __exports__